<script>
export default {
  props: {
    id: { type: String, required: true },
    producto: { type: Object, required: true },
  },
  data() {
    return {
      bloques: this.getConfigInicial(),
      campos: [
        { name: "foto", label: "Imagen" },
        { name: "nombre", label: "T&iacute;tulo" },
        { name: "dias_noches", label: "D&iacute;as / Noches" },
        { name: "fecha_salida", label: "Fecha de salida" },
        { name: "tarifa", label: "Precio desde" },
        { name: "ciudades", label: "Ciudades que visita" },
      ],
    };
  },
  computed: {
    editado() {
      return (
        JSON.stringify(this.producto.destacado_en_bloques) !==
        JSON.stringify(this.bloques)
      );
    },
  },
  methods: {
    getConfigInicial() {
      // Creamos una copia profunda
      const bloques = JSON.parse(
        JSON.stringify(this.producto.destacado_en_bloques)
      );
      return bloques.map((b) => ({
        ...b,
        campos: Array.isArray(b.campos) ? b.campos : Object.values(b.campos),
      }));
    },
    guardar() {
      this.$emit("update:destacado_en_bloques", this.bloques);
    },
    cancelar(e) {
      // Deshabilitamos bloques sin campos
      // Esta lógica está también en el back. Necesitamos aplicarla acá para
      // que coincidan los bloques actualizados desde el back con los del front
      // y funcione la verificación que hace this.editado
      this.bloques = this.bloques.map((b) => ({
        ...b,
        habilitado: b.campos.length > 0 ? b.habilitado : false,
      }));
      if (this.editado) {
        const ok = confirm("Los cambios sin guardar se van a descartar");
        if (!ok) {
          e.stopPropagation();
        } else {
          // Restablecemos la config para evitar desincronización con datos guardados
          this.bloques = this.getConfigInicial();
        }
      }
    },
  },
};
</script>
<template>
  <div>
    <div class="modal fade" :id="id">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Cerrar"
              title="Cerrar"
              @click="cancelar($event)"
            >
              <span aria-hidden="true" v-html="'&times;'" />
            </button>
            <h3 class="modal-title">{{ producto.nombre }}</h3>
          </div>
          <div class="modal-body">
            <h4 class="modal-subtitle">Productos destacados</h4>
            <fieldset v-for="bloque in bloques">
              <legend>
                <label class="list-group-item">
                  <input
                    :name="`${bloque.id}`"
                    v-model="bloque.habilitado"
                    type="checkbox"
                  />
                  <span>Bloque #{{ bloque.id }}</span>
                </label>
              </legend>
              <div class="list-group">
                <label v-for="c in campos" class="list-group-item">
                  <input
                    type="checkbox"
                    v-model="bloque.campos"
                    :value="c.name"
                    :name="`${bloque.id}-${c.name}`"
                    :disabled="!bloque.habilitado"
                  />
                  <span v-html="c.label" />
                </label>
              </div>
            </fieldset>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="guardar"
              :disabled="!editado"
            >
              Guardar cambios
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="cancelar($event)"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.modal-header {
  background-color: var(--primary);
}
.modal-title {
  color: #fff;
}
.close {
  color: #fff;
  opacity: 1;
}
legend {
  padding: 10px 0;
  margin: 10px 0 0;
}
.list-group-item {
  padding: 10px !important;
  border: none;
}
.btn-primary {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}
.btn-primary:focus,
.btn-primary:hover {
  background-color: #204d74;
  border-color: #122b40;
}
</style>